export default __webpack_public_path__ + "static/media/logo.df4c6415.png";